import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Layout } from 'antd';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import Breadcrumbs from '../../../components/LayoutComponents/Breadcrumbs';
import { getJson, API_URL } from '../../../helpers/api/api';
import ProjectForm from '../../../components/CbsComponents/ProjectForm/ProjectForm';
import { store } from '../../../redux/store';

const NewProject: React.FC<WrappedComponentProps> = ({ intl }) => {
  const [teamLeads, setTeamLeads] = useState<string[]>();
  const breadcrumbs = [
    {
      title: 'menu.projects',
      href: '/projects',
    },
    {
      title: 'add',
      href: `/projects/new`,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const projectId = store.getState().user.currentProjectId;
      const list = await getJson(`${API_URL}/projects/${projectId}/projects`);
      setTeamLeads(list.data);
    };
    fetchData();
  }, []);

  if (!teamLeads) return null;

  return (
    <Layout.Content style={{ height: '100%', position: 'relative' }}>
      <Helmet title={intl.formatMessage({ id: 'menu.addProjects' })} />
      <div className="utils__content">
        <div style={{ marginBottom: '20px' }}>
          <div className="page-title">
            <FormattedMessage id="menu.projects" />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <ProjectForm />
      </div>
    </Layout.Content>
  );
};

export default injectIntl(NewProject);
